import { useAlert } from 'react-alert'

import { useOnChangeDetect, useModalBox } from '../../contexts'
import { Button } from '..'

type ResetModalProps = {
  setDocument: any
  setDocumentData: any
  resetDocument: any
  id: number
  loading: boolean
  document: string
}

const ResetModal = ({
  id,
  loading,
  document,
  resetDocument,
  setDocument,
  setDocumentData
}: ResetModalProps) => {
  const { modalClose } = useModalBox()
  const { setRefresh } = useOnChangeDetect()
  const alert = useAlert()

  const handleResetReport = async (id: number | string) => {
    try {
      const responseReset = await resetDocument({
        id: id
      }).load()
      modalClose(true)
      alert.show(`${document} resetado com sucesso`, {
        type: 'success',
        timeout: 4000
      })

      setDocument(responseReset)
      setDocumentData(responseReset?.[document.replace('çã', 'ca')])
      setRefresh((prev: any) => !prev)
    } catch (error) {
      console.error(error)
      alert.show(`Erro ao resetar um ${document}`, {
        type: 'error',
        timeout: 4000
      })
    }
  }

  return (
    <div className="delete-modal">
      <p className="attention-label">
        ATENÇÃO: Todas as edições serão perdidas
      </p>
      <p>Deseja realmente resetar o {document}?</p>
      <div>
        <Button
          hasredButton
          disabled={loading}
          onClick={() => handleResetReport(id)}
        >
          Sim
        </Button>
        <Button hasSecodaryButton onClick={modalClose}>
          Não
        </Button>
      </div>
    </div>
  )
}

export default ResetModal
